import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column } from '../Column/Column.js';
import { Icon } from '../Icon/Icon.js';
import { Text } from '../Text/Text.js';
export function EmptyStateMessage({ icon, title, message }) {
    return (_jsxs(Column, { className: "is-height-100", alignItems: "center", justifyContent: "center", padding: 5, gap: 3, children: [_jsx(Icon, { icon: icon, size: "large" }), _jsx(Text, { textStyle: "headline4", children: title }), _jsx(Text, { textStyle: "body1", className: "is-max-width-40rem", children: message })] }));
}
//# sourceMappingURL=EmptyStateMessage.js.map